import { buildAshleyPersonalizedGreeting } from "../../speech/ashleyGreeting";

export const GREETING_PROVIDER_ID = "greeting";

export const greetingProvider = {
  id: GREETING_PROVIDER_ID,
  isEligible: () => true,
  buildSection(ctx) {
    return buildAshleyPersonalizedGreeting(ctx.displayName, ctx.date);
  },
};
